import styled from "styled-components";
import { Card } from "react-bootstrap";

export const Container = styled(Card)`
  width: 100%;
  height: 62px;
  background-color: #ffffff;
  -webkit-box-pack: justify;
  justify-content: space-between;
  padding: 15px 0px;
  border-radius: 8px;
  box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.1);
  border: 0.5px solid #c9c9c9;
  display: flex;
  flex-direction: row;
  align-items: center;
  @media (max-width: 1100px) {
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
  }
`;

export const SubContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex: 1;
  padding-left: 10;
  justify-content: space-between;
`;

export const Left = styled.div`
  padding-right: 20px;
  flex: 1;
  margin-left: 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: row;
  @media (max-width: 1113px) {
    margin-left: 10px;
    justify-content: flex-start;
  }
  `;

export const Right = styled.div`
  width: 50%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: row;
  padding-left: 20px; 
  gap: 10px;
  
  @media (max-width: 1113px) {
    justify-content: flex-end;
  }
`;

export const Title = styled.div`
  font-size: 16px;
  color: #000FFF;
  cursor: pointer;
  width: 50%;

`;

export const TitleDetails = styled.div`
  font-size: 14px;
  color: #000FFF;
`;

export const ItemDetails = styled.span`
  display: flex;
  color: #808080;
  font-size: 14px;
  font-weight: 300;
  margin-left: 27px;
  justify-content: center;
  align-items: center;
  flex-direction: row;
  gap: 5px;
`;

export const DownloadButton = styled.div``;

export const DownloadIcon = styled.i`
  cursor: pointer;
  color: #487cf5;
  font-size: 25px;
`;

export const Divisor = styled.div`
  width: 1px;
  height: 41px;
  background-color: #c9c9c9;
  margin-left: 15px;
  margin-right: 15px;
  @media (max-width: 768px) {
    visibility: hidden;
  }
`;

export const Details = styled.div`
  margin-left: 2px;
  padding: 0px 10px;
  height: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${(props) => props.color ? "#c9c9c9" : "#000FFF" };
  color: #fff;
  font-size: 10px;
  border-top-left-radius: 25px;
  border-bottom-left-radius: 25px;
  cursor: pointer;
  min-width: 42%;
`;

export const IconInformation = {
  width: 10,
  height: 10,
  marginLeft: 5,
};

export const IconInformationBlue = {
  width: 18,
  height: 18,
};

export const IconPix = {
  width: 18,
  height: 18,
};

export const ToolTipText = styled.span``;

export const ToolTipButton = styled.a`
  cursor: pointer;
`;

export const QrCodeStyle = styled.div`
  width: 15%;
  margin: 0 5px;
`;